module.exports = "/images/Homepage-ExteriorM.jpg";